const scrollTo = function () {
  jQuery('.in-page-scroll').on('click', function () {
    const destination = $(this).attr('data-scroll-to');
    jQuery('html, body').animate({ scrollTop: jQuery(`[data-scroll-target=${destination}]`).offset().top }, 1000);
  });
};
export { scrollTo };
